<template>
    <lib-tippy
        :delay="[50, 0]"
        :placement="placement"
        animation="shift-toward"
        arrow
        class="cursor-pointer"
    >
        <template #trigger>
            <slot/>
        </template>
        <div v-if="$slots.content">
            <slot name="content"></slot>
        </div>
        <div v-else>{{ content }}</div>
    </lib-tippy>
</template>

<script>
export default {
  name: 'BaseTippy',
  props: {
    content: String,
    placement: {
      type: String,
      default: 'top-end',
      validator (value) {
        return [
          'top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'auto', 'auto-start', 'auto-end'
        ].includes(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
